import { BarChart, Bar, Tooltip, ResponsiveContainer } from 'recharts'
import { formatCost } from '@lens/lib/decode'
import type { ProjectCost } from '@lens/types/claude'
import { CHART_TOOLTIP_STYLE, ChartGrid, ChartXAxis, ChartYAxis } from '../chart-primitives'

interface Props {
 projects: ProjectCost[]
}

export function CostByProjectChart({ projects }: Props) {
 const top = projects.slice(0, 12)

 return (
  <div>
   <ResponsiveContainer width="100%" height={Math.max(120, top.length * 28)}>
    <BarChart data={top} layout="vertical" margin={{ top: 0, right: 60, bottom: 0, left: 8 }}>
     <ChartGrid horizontal={false} />
     <ChartXAxis type="number" tickFormatter={(v: number) => formatCost(v)} />
     <ChartYAxis type="category" dataKey="display_name" width={90} />
     <Tooltip
      contentStyle={CHART_TOOLTIP_STYLE}
      formatter={(val) => [formatCost(typeof val === 'number' ? val : 0), 'Estimated cost']}
     />
     <Bar dataKey="estimated_cost" radius={[0, 3, 3, 0]} fill="var(--chart-1)" isAnimationActive={false} />
    </BarChart>
   </ResponsiveContainer>
  </div>
 )
}
